import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';

import { RecaptchaModule } from 'ng-recaptcha';

import { IonicModule } from '@ionic/angular';

import { ComponentsModule, CoreUiModule } from '@ridango/components';
import { CoreModule } from '@ridango/core';
import { FeatureFlagsModule } from '@ridango/feature-flags';
import { UiModule } from '@ridango/ui';
import { WidgetsModule } from '@ridango/widgets';

import { ContainersModule } from '../containers/containers/containers.module';
import { SharedModule } from '../shared/shared.module';
import { AccountChangeEmailPageComponent } from './account-change-email-page/account-change-email-page.component';
import { AccountChangePasswordPageComponent } from './account-change-password-page/account-change-password-page.component';
import { AccountDetailPageComponent } from './account-detail-page/account-detail-page.component';
import { AccountEditPageComponent } from './account-edit-page/account-edit-page.component';
import { AccountParentPageComponent } from './account-parent-page/account-parent-page.component';
import { BalancePageComponent } from './balance-page/balance-page.component';
import { BankcardTicketsPageComponent } from './bankcard-tickets-page/bankcard-tickets-page.component';
import { BikeGaragePageComponent } from './bike-garage-page/bike-garage-page.component';
import { CustomerForgetLandingPageComponent } from './customer-forget-landing-page/customer-forget-landing-page.component';
import { CustomerSupportPageComponent } from './customer-support-page/customer-support-page.component';
import { EmailVerificationPageComponent } from './email-verification-page/email-verification-page.component';
import { ExploreScheduleOnStopAdditionalInfoPageComponent } from './explore-page/explore-schedule-on-stop-additional-info-page/explore-schedule-on-stop-additional-info-page.component';
import { HomePageComponent } from './home-page/home-page.component';
import { IsicCardActivationPageComponent } from './isic-card-activation-page/isic-card-activation-page.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { MyProfileParentPageComponent } from './my-profile-parent-page/my-profile-parent-page.component';
import { PasswordRecoverPageComponent } from './password-recover-page/password-recover-page.component';
import { PasswordRecoverVerificationPageComponent } from './password-recover-verification-page/password-recover-verification-page.component';
import { PaymentResultPageComponent } from './payment-result-page/payment-result-page.component';
import { PersonalizeParentPageComponent } from './personalize-parent-page/personalize-parent-page.component';
import { PurchaseHistoryPageComponent } from './purchase-history-page/purchase-history-page.component';
import { PurchasePageComponent } from './purchase-page/purchase-page.component';
import { RegisterPageComponent } from './register-page/register-page.component';
import { RegisterVerificationPageComponent } from './register-verification-page/register-verification-page.component';
import { RelatedCardAddAndEditPageComponent } from './related-card-add-and-edit-page/related-card-add-and-edit-page.component';
import { RelatedCardDetailPageComponent } from './related-card-detail-page/related-card-detail-page.component';
import { RelatedCardListPageComponent } from './related-card-list-page/related-card-list-page.component';
import { RelatedCardPersonalizePageComponent } from './related-card-personalize-page/related-card-personalize-page.component';
import { ScheduleFavouritesPageComponent } from './schedule-page/schedule-favourites-page/schedule-favourites-page.component';
import { ScheduleParentPageComponent } from './schedule-page/schedule-parent-page/schedule-parent-page.component';
import { SchedulePlannerPageComponent } from './schedule-page/schedule-planner-page/schedule-planner-page.component';
import { SchedulePlannerTripDetailsPageComponent } from './schedule-page/schedule-planner-trip-details-page/schedule-planner-trip-details-page.component';
import { ScheduleRouteDirectionsPageComponent } from './schedule-page/schedule-route-directions-page/schedule-route-directions-page.component';
import { ScheduleRouteStopDetailsPageComponent } from './schedule-page/schedule-route-stop-details-page/schedule-route-stop-details-page.component';
import { ScheduleRouteStopsPageComponent } from './schedule-page/schedule-route-stops-page/schedule-route-stops-page.component';
import { ScheduleRouteTripPageComponent } from './schedule-page/schedule-route-trip-page/schedule-route-trip-page.component';
import { ScheduleRoutesPageComponent } from './schedule-page/schedule-routes-page/schedule-routes-page.component';
import { ScheduleSearchPageComponent } from './schedule-page/schedule-search-page/schedule-search-page.component';
import { SeutulippuPageComponent } from './seutulippu-page/seutulippu-page.component';
import { SeutulippuRegisterPageComponent } from './seutulippu-register-page/seutulippu-register-page.component';
import { ShoppingCartPageComponent } from './shopping-cart-page/shopping-cart-page.component';
import { SwishConfirmationPageComponent } from './swish-confirmation-page/swish-confirmation-page.component';
import { TermsPageComponent } from './terms-page/terms-page.component';
import { TravelcardsAndTicketsParentPageComponent } from './travelcards-and-tickets-parent-page/travelcards-and-tickets-parent-page.component';
import { ValidationHistoryPageComponent } from './validation-history-page/validation-history-page.component';
import { WalletLoadingPageComponent } from './wallet-loading-page/wallet-loading-page.component';
import { BookRideParentPageComponent } from './book-ride-page/book-ride-parent-page/book-ride-parent-page.component';
import { BookRidePlanPageComponent } from './book-ride-page/book-ride-plan-page/book-ride-plan-page.component';
import { BookRideSpecifyPageComponent } from './book-ride-page/book-ride-specify-page/book-ride-specify-page.component';
import { BookRideReviewPageComponent } from './book-ride-page/book-ride-review-page/book-ride-review-page.component';
import { RideHistoryPageComponent } from './account-ride-history-page/ride-history-page.component';
import { BookingsPageComponent } from './account-bookings-page/account-bookings-page.component';
import { AdyenPaymentPageComponent } from './adyen-payment-page/adyen-payment-page.component';
import { TicketsParentPageComponent } from './tickets-parent-page/tickets-parent-page.component';
import { SwiperModule } from 'swiper/angular';
import { HomePageStwComponent } from './home-page/home-page-stw/home-page-stw.component';
import { AppAdyenPaymentComponent } from './app-adyen-payment/app-adyen-payment.component';
import { OndemandTripsPageComponent } from './ondemand-trips-page/ondemand-trips-page.component';
import { AccountCompaniesPageComponent } from './account-companies-page/account-companies-page.component';
import { JourneyPlannerPageComponent } from './journey-planner-page/journey-planner-page.component';
import { JourneyPlannerSearchComponent } from './journey-planner-page/journey-planner-search/journey-planner-search.component';
import { JourneyPlannerResultsComponent } from './journey-planner-page/journey-planner-results/journey-planner-results.component';
import { ExplorePageComponent } from './explore-page/explore-page.component';
import { DisruptionMessagesPageComponent } from './disruption-messages-page/disruption-messages-page.component';
import { TicketsPageComponent } from './tickets-page/tickets-page.component';
import { AccountCompanyUsersListPageComponent } from './account-company-users-list-page/account-company-users-list-page.component';
import { AccountCompanyUsersAddPageComponent } from './account-company-users-add-page/account-company-users-add-page.component';
import { AccountCompanyEditPageComponent } from './account-company-edit-page/account-company-edit-page.component';
import { NotificationSettingsPageComponent } from './notification-settings-page/notification-settings-page.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TicketDetailsPageComponent } from './ticket-details-page/ticket-details-page.component';
import { ExploreSearchPageComponent } from './explore-page/explore-search-page/explore-search-page.component';
import { ExploreTripDetailsPageComponent } from './explore-page/explore-trip-details-page/explore-trip-details-page.component';
import { ExploreStopDetailsPageComponent } from './explore-page/explore-stop-details-page/explore-stop-details-page.component';
import { JourneyPlannerItineraryDetailsComponent } from './journey-planner-page/journey-planner-itinerary-details/journey-planner-itinerary-details.component';
import { ExploreRoutePatternsPageComponent } from './explore-page/explore-route-patterns-page/explore-route-patterns-page.component';
import { FeedbackPageComponent } from './feedback-page/feedback-page.component';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { ExploreScheduleOnStopPageComponent } from './explore-page/explore-schedule-on-stop-page/explore-schedule-on-stop-page.component';
import { AccountCardsParentPageComponent } from './account-cards-page/account-cards-parent-page.component';
import { CardsPageLayoutContainerComponent } from './account-cards-page/cards-page-layout-container/cards-page-layout-container.component';
import { CardsLandingPageComponent } from './account-cards-page/cards-landing-page/cards-landing-page.component';
import { CardsDetailsPageComponent } from './account-cards-page/cards-details-page/cards-details-page.component';
import { CardsEditPageComponent } from './account-cards-page/cards-add-edit-page/cards-edit-page.component';
import { CardsAddEditBaseComponent } from './account-cards-page/cards-add-edit-page/cards-add-edit-base.component';
import { CardsAddPageComponent } from './account-cards-page/cards-add-edit-page/cards-add-page.component';
import { FaqPageComponent } from './faq-page/faq-page.component';
import { CemvFaqPageComponent } from './cemv-faq-page/cemv-faq-page.component';
import { OnboardingPageComponent } from './onboarding-page/onboarding-page.component';
import { MapPageComponent } from './map-page/map-page.component';
import { PrivacyPageComponent } from './privacy-page/privacy-page.component';
import { ViispPageComponent } from './viisp-page/viisp-page.component';
import { PreferencesComponent } from './purchase-page-v2/preferences/preferences.component';
import { PurchasePageV2WrapperComponent } from './purchase-page-v2/purchase-page-v2-wrapper/purchase-page-v2-wrapper.component';
import { AreasComponent } from './purchase-page-v2/areas/areas.component';
import { AccountSelectorComponent } from '../shared/components/account-selector/account-selector.component';
import { ProductAreaComponent } from './purchase-page-v2/product-area/product-area.component';
import { CategoryProductComponent } from './purchase-page-v2/category-product/category-product.component';
import { ProductComponent } from './purchase-page-v2/product/product.component';
import { ActivationComponent } from './purchase-page-v2/activation/activation.component';
import { CityOrMunicipalityAreaComponent } from './purchase-page-v2/product-area/city-or-municipality-area/city-or-municipality-area.component';
import { FromAToBAreaComponent } from './purchase-page-v2/product-area/from-a-to-b-area/from-a-to-b-area.component';
import { SingleOrTwoAreaComponent } from './purchase-page-v2/product-area/single-or-two-area/single-or-two-area.component';
import { AreaImageComponent } from './purchase-page-v2/product-area/single-or-two-area/area-image/area-image.component';
import { ExploreLocationPageComponent } from './explore-page/explore-location-page/explore-location-page.component';
import { ShoppingCartPageV2Component } from './shopping-cart-page-v2/shopping-cart-page.component';
import { ShoppingCartTicketComponent } from './shopping-cart-page-v2/shopping-cart-ticket/shopping-cart-ticket.component';
import { ShoppingCartCompanyComponent } from './shopping-cart-page-v2/shopping-cart-company/shopping-cart-company.component';
import { SelectPurposeModalComponent } from './shopping-cart-page-v2/select-purpose-modal/select-purpose-modal.component';
import { PaymentSettingsPageComponent } from './payment-settings-page/payment-settings-page.component';
import { AddCompanyModalComponent } from './payment-settings-page/add-company-modal/add-company-modal.component';
import { RemoveCreditCardModalComponent } from './payment-settings-page/remove-credit-card-modal/remove-credit-card-modal.component';
import { SelectCountryCodeModalComponent } from './payment-settings-page/select-country-code-modal/select-country-code-modal.component';
import { MultiplePaymentMethodsV2Component } from './shopping-cart-page-v2/payment-methods/multiple-payment-methods-v2/multiple-payment-methods-v2.component';
import { SinglePaymentMethodV2Component } from './shopping-cart-page-v2/payment-methods/single-payment-method-v2/single-payment-method-v2.component';
import { OtherPurposeModalComponent } from './shopping-cart-page-v2/other-purpose-modal/other-purpose-modal.component';
import { PaymentResultPageV2Component } from './payment-result-page-v2/payment-result-page-v2.component';
import { V2NavigateAwayModalComponent } from './shopping-cart-page-v2/navigate-away-modal/navigate-away-modal.component';
import { PasswordRecoverPageV2Component } from './password-recover-page-v2/password-recover-page-v2.component';
import { SavedPaymentMethodComponent } from './shopping-cart-page-v2/payment-methods/saved-payment-method/saved-payment-method.component';
import { DeleteSavedPaymentMethodModalComponent } from './shopping-cart-page-v2/payment-methods/delete-saved-payment-method-modal/delete-saved-payment-method-modal.component';
import { FavoriteTicketsComponent } from './purchase-page-v2/favorite-tickets/favorite-tickets.component';
import { JourneyPlannerPurchaseTicketsPageComponent } from './journey-planner-purchase-tickets-page/journey-planner-purchase-tickets-page.component';
import { ValueCodeModalComponent } from './shopping-cart-page-v2/value-code-modal/value-code-modal.component';
import { DeleteValueCodeModalComponent } from './shopping-cart-page-v2/delete-value-code-modal/delete-value-code-modal.component';
import { PurchasePageV2BaseComponent } from './purchase-page-v2/purchase-page-v2-base.component';
import { SelectNewPaymentMethodModalComponent } from './shopping-cart-page-v2/payment-methods/select-new-payment-method-modal/select-new-payment-method-modal.component';
import { SinglePaymentPortalMethodComponent } from './shopping-cart-page-v2/payment-methods/single-payment-portal-method/single-payment-portal-method.component';
import { ExploreRouteGroupPageComponent } from './explore-page/explore-route-group-page/explore-route-group-page.component';
import { BankCardsAddEditComponent } from './account-cards-page/bank-cards-add-edit-page/bank-cards-add-edit.component';
import { TicketQrPageComponent } from './ticket-qr-page/ticket-qr-page.component';
import { PasswordRecoverVerificationPageV2Component } from './password-recover-verification-page-v2/password-recover-verification-page.component';
import { EditTicketFavoritesModalComponent } from './purchase-page-v2/favorite-tickets/edit-ticket-favorites-modal/edit-ticket-favorites-modal.component';
import { AccountMessagesPageComponent } from './account-messages-page/account-messages-page.component';
import { MessagesDetailPageComponent } from './account-messages-page/messages-detail-page/messages-detail-page.component';
import { BannerDetailsPageComponent } from './banner-details-page/banner-details-page.component';
import { LeavePurchaseModalComponent } from './shopping-cart-page-v2/leave-purchase-modal/leave-purchase-modal.component';
import { CorporatePortalPageComponent } from './corporate-portal/corporate-portal.component';
import { RetailersPageComponent } from './retailers-page/retailers-page.component';
import { DepartmentProfileAddComponent } from './department-profile-add/department-profile-add.component';
import { FeedbackModalModule } from './home-page/feedback-modal-component/feedback-modal.module';
import { AccountSelectorDialogComponent } from '../shared/components/account-selector/account-selector-dialog/account-selector-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { AddNotificationsPageComponent } from './add-notifications-page/add-notifications-page.component';
import { EditSubscriptionsPageComponent } from './edit-subscriptions-page/edit-subscriptions-page.component';
import { EmailConfirmPageComponent } from './email-confirmation/email-confirmation.component';
import { AddSubscriptionsPageComponent } from './add-subscriptions-page/add-subscriptions-page.component';
import { AccountPersonalizePageComponent } from './account-personalize-page/account-personalize-page.component';
import { TicketPurchaseSameValidityConfirmationComponent } from './purchase-page-v2/ticket-purchase-same-validity-confirmation/ticket-purchase-same-validity-confirmation.component';
import { CardInfoPageComponent } from './card-info-page/card-info-page.component';
import { AccessibilityNoticePageComponent } from './accessibility-notice-page/accessibility-notice-page.component';
import { OidcAuthPageComponent } from './oidc-auth-page/oidc-auth-page.component';
import { SignupCompletePageComponent } from './signup-complete-page/signup-complete-page.component';

@NgModule({
    declarations: [
        LoginPageComponent,
        HomePageComponent,
        HomePageStwComponent,
        RegisterPageComponent,
        RegisterVerificationPageComponent,
        EmailVerificationPageComponent,
        PurchasePageComponent,
        PurchasePageV2WrapperComponent,
        PurchasePageV2BaseComponent,
        JourneyPlannerPurchaseTicketsPageComponent,
        PreferencesComponent,
        AreasComponent,
        AccountSelectorComponent,
        AccountSelectorDialogComponent,
        ProductAreaComponent,
        BannerDetailsPageComponent,
        CategoryProductComponent,
        ProductComponent,
        ExploreRouteGroupPageComponent,
        ActivationComponent,
        WalletLoadingPageComponent,
        ShoppingCartPageComponent,
        PaymentResultPageComponent,
        PaymentResultPageV2Component,
        RelatedCardAddAndEditPageComponent,
        RelatedCardDetailPageComponent,
        TermsPageComponent,
        PrivacyPageComponent,
        PasswordRecoverPageComponent,
        PasswordRecoverPageV2Component,
        PasswordRecoverVerificationPageV2Component,
        PasswordRecoverVerificationPageComponent,
        MyProfileParentPageComponent,
        AccountDetailPageComponent,
        AccountEditPageComponent,
        AccountChangePasswordPageComponent,
        AccountChangeEmailPageComponent,
        BalancePageComponent,
        PurchaseHistoryPageComponent,
        RelatedCardListPageComponent,
        BikeGaragePageComponent,
        TravelcardsAndTicketsParentPageComponent,
        AccountParentPageComponent,
        ValidationHistoryPageComponent,
        CustomerForgetLandingPageComponent,
        SwishConfirmationPageComponent,
        ScheduleParentPageComponent,
        ScheduleSearchPageComponent,
        ScheduleRoutesPageComponent,
        ScheduleRouteDirectionsPageComponent,
        ScheduleRouteStopDetailsPageComponent,
        ScheduleRouteStopsPageComponent,
        ScheduleFavouritesPageComponent,
        ScheduleRouteTripPageComponent,
        SchedulePlannerPageComponent,
        SchedulePlannerTripDetailsPageComponent,
        RelatedCardPersonalizePageComponent,
        BankcardTicketsPageComponent,
        IsicCardActivationPageComponent,
        PersonalizeParentPageComponent,
        CustomerSupportPageComponent,
        BookRideParentPageComponent,
        BookRidePlanPageComponent,
        BookRideSpecifyPageComponent,
        BookRideReviewPageComponent,
        RideHistoryPageComponent,
        BookingsPageComponent,
        SeutulippuPageComponent,
        SeutulippuRegisterPageComponent,
        TicketsParentPageComponent,
        AppAdyenPaymentComponent,
        AdyenPaymentPageComponent,
        OndemandTripsPageComponent,
        AccountCompaniesPageComponent,
        AccountCompanyEditPageComponent,
        JourneyPlannerPageComponent,
        JourneyPlannerSearchComponent,
        JourneyPlannerResultsComponent,
        ExplorePageComponent,
        DisruptionMessagesPageComponent,
        TicketsPageComponent,
        AccountCompanyUsersListPageComponent,
        AccountCompanyUsersAddPageComponent,
        NotificationSettingsPageComponent,
        TicketDetailsPageComponent,
        TicketQrPageComponent,
        AccountMessagesPageComponent,
        MessagesDetailPageComponent,
        ExploreSearchPageComponent,
        ExploreTripDetailsPageComponent,
        ExploreStopDetailsPageComponent,
        ExploreScheduleOnStopAdditionalInfoPageComponent,
        AccountCardsParentPageComponent,
        CardsPageLayoutContainerComponent,
        CardsLandingPageComponent,
        ExploreRoutePatternsPageComponent,
        FeedbackPageComponent,
        ExploreScheduleOnStopPageComponent,
        JourneyPlannerItineraryDetailsComponent,
        AccountCardsParentPageComponent,
        CardsPageLayoutContainerComponent,
        CardsLandingPageComponent,
        CardsAddPageComponent,
        CardsDetailsPageComponent,
        CardsEditPageComponent,
        CardsAddEditBaseComponent,
        FaqPageComponent,
        OnboardingPageComponent,
        BankCardsAddEditComponent,
        MapPageComponent,
        ViispPageComponent,
        CityOrMunicipalityAreaComponent,
        FromAToBAreaComponent,
        SingleOrTwoAreaComponent,
        AreaImageComponent,
        ExploreLocationPageComponent,
        ShoppingCartPageV2Component,
        V2NavigateAwayModalComponent,
        ShoppingCartTicketComponent,
        MultiplePaymentMethodsV2Component,
        SinglePaymentMethodV2Component,
        SinglePaymentPortalMethodComponent,
        ShoppingCartCompanyComponent,
        SelectPurposeModalComponent,
        LeavePurchaseModalComponent,
        OtherPurposeModalComponent,
        PaymentSettingsPageComponent,
        AddCompanyModalComponent,
        RemoveCreditCardModalComponent,
        SelectCountryCodeModalComponent,
        SavedPaymentMethodComponent,
        DeleteSavedPaymentMethodModalComponent,
        SelectNewPaymentMethodModalComponent,
        TicketPurchaseSameValidityConfirmationComponent,
        FavoriteTicketsComponent,
        EditTicketFavoritesModalComponent,
        ValueCodeModalComponent,
        DeleteValueCodeModalComponent,
        CorporatePortalPageComponent,
        RetailersPageComponent,
        CemvFaqPageComponent,
        DepartmentProfileAddComponent,
        AddNotificationsPageComponent,
        EditSubscriptionsPageComponent,
        EmailConfirmPageComponent,
        AddSubscriptionsPageComponent,
        AccountPersonalizePageComponent,
        CardInfoPageComponent,
        AccessibilityNoticePageComponent,
        OidcAuthPageComponent,
        SignupCompletePageComponent
    ],
    imports: [
        CommonModule,
        BrowserModule,
        ComponentsModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        CoreModule,
        SharedModule,
        CoreUiModule,
        ContainersModule,
        TranslateModule,
        LocalizeRouterModule.forChild([]),
        WidgetsModule,
        UiModule,
        MatDialogModule,
        MatIconModule,
        MatRadioModule,
        MatButtonModule,
        FeatureFlagsModule,
        SwiperModule,
        MatSlideToggleModule,
        MatTabsModule,
        IonicModule.forRoot(),
        MatCardModule,
        MatInputModule,
        MatSelectModule,
        RecaptchaModule,
        FeedbackModalModule
    ],
    exports: []
})
export class PagesModule {}
